import axios from 'axios'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { baseURL } from './baseUrl'
import { msalInstance } from 'index'
import { loginRequest } from 'components/sso/authConfig'

const BaseService = axios.create({
  timeout: 60000,
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

BaseService.interceptors.request.use(async (config) => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]

  if (!account) return config

  try {
    const tokenResult = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    })

    config.headers.Authorization = `Bearer ${tokenResult.idToken}`
    return config
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ ...loginRequest, account })
    }
    throw e
  }
})

BaseService.interceptors.response.use(
  (r) => r,
  async (error) => {
    const status = error?.response?.status

    if (status === 401) {
      const originalRequest = error.config
      if (!originalRequest._retry) {
        originalRequest._retry = true

        const account =
          msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]

        if (account) {
          try {
            const tokenResult = await msalInstance.acquireTokenSilent({
              ...loginRequest,
              account,
              forceRefresh: true,
            })
            originalRequest.headers.Authorization = `Bearer ${tokenResult.idToken}`
            return BaseService.request(originalRequest)
          } catch {}
        }
      }
    }

    return Promise.reject(error)
  },
)

export default BaseService
